import cs from 'classnames';
import { DownloadIcon } from '@forgeglobal/design-framework';
import { AuthenticatedLink } from '@tcs/client-portal-common/components/molecules/AuthenticatedLink';
import { useStyles } from '../style';

interface CellProps {
  url: string;
  fileName?: string;
}

const DownloadCell = ({ url, fileName }: CellProps) => {
  const classes = useStyles({});
  if (!url) return null;

  return (
    <div className={cs(classes.baseCell)}>
      <AuthenticatedLink
        to={url}
        url={url}
        className={classes.downloadLink}
        defaultFileName={fileName}
        openInNewTab>
        View
      </AuthenticatedLink>
      <AuthenticatedLink
        to={url}
        url={url}
        className={classes.downloadLink}
        defaultFileName={fileName}
        openInNewTab={false}>
        <DownloadIcon className={classes.downloadIcon} />
      </AuthenticatedLink>
    </div>
  );
};

export default DownloadCell;
